import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { JeevesCustomerContactListConfigService } from 'gung-standard-jeeves';
import { CustomerContact } from 'gung-standard';
import { CultCustomerContactCardListComponent } from '../components/cult-customer-contact-card-list/cult-customer-contact-card-list.component';

@Injectable({
  providedIn: 'root'
})
export class CultCustomerContactListConfigService extends JeevesCustomerContactListConfigService {
  getLayouts(): ListLayout<CustomerContact>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CultCustomerContactCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'CustomerContacts grid'
      }
    ];
  }
}
